module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_wedding_movie-d6a65bb9fdb61b53d33cf0d9736a3174.jpg";